export default __webpack_public_path__ + "static/media/pins.56eacfbc.svg";